
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("g0fSg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $8m50u = parcelRequire("8m50u");


var $g9ZnD = parcelRequire("g9ZnD");


var $gIMcb = parcelRequire("gIMcb");

const $e5bbb38f64c6a3e7$export$9f7977d4a2561bee = (Component)=>(0, $8m50u.componentWithCondition)(()=>(0, $iDrrr.fg)('media-perf-uplift-mutation-fix'), ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>{
        const existingMediaClient = (0, $cozmU.useContext)((0, $gIMcb.MediaClientContext));
        const mediaClient = (0, $cozmU.useMemo)(()=>existingMediaClient ?? (0, $g9ZnD.getMediaClient)(mediaClientConfig), [
            mediaClientConfig,
            existingMediaClient
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gIMcb.MediaClientContext).Provider, {
            value: mediaClient
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ...otherProps,
            mediaClient: mediaClient
        }));
    }, ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gIMcb.MediaClientContext).Consumer, null, (value)=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                ...otherProps,
                mediaClient: value
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gIMcb.MediaClientProvider), {
                clientConfig: mediaClientConfig
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gIMcb.MediaClientContext).Consumer, null, (client)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                    ...otherProps,
                    mediaClient: client
                })))));
module.exports["withMediaClient"] = $e5bbb38f64c6a3e7$export$9f7977d4a2561bee;

});

parcelRegister("h7nb4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lNvN4 = parcelRequire("lNvN4");


var $4fGOw = parcelRequire("4fGOw");

const $387adc567339a7f4$export$90ff537b0999afb = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFileState(id, t0) {
    const $ = (0, $bDgLe.c)(15);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const options = t1;
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: t2, includeHashForDuplicateFiles: includeHashForDuplicateFiles, initialFileState: initialFileState } = options;
    const skipRemote = t2 === undefined ? false : t2;
    const mediaClient = (0, $lNvN4.useMediaClient)();
    let t3;
    if ($[2] !== id) {
        t3 = (state)=>state.files[id];
        $[2] = id;
        $[3] = t3;
    } else t3 = $[3];
    const fileState = (0, $4fGOw.useMediaStore)(t3);
    const initialFileStateRef = (0, $cozmU.useRef)(initialFileState);
    let t4;
    let t5;
    if ($[4] !== collectionName || $[5] !== fileState || $[6] !== id || $[7] !== includeHashForDuplicateFiles || $[8] !== mediaClient || $[9] !== occurrenceKey || $[10] !== skipRemote) {
        t4 = ()=>{
            if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
                initialFileState: initialFileStateRef.current,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey,
                includeHashForDuplicateFiles: includeHashForDuplicateFiles
            });
        };
        t5 = [
            id,
            mediaClient,
            collectionName,
            occurrenceKey,
            skipRemote,
            fileState,
            includeHashForDuplicateFiles
        ];
        $[4] = collectionName;
        $[5] = fileState;
        $[6] = id;
        $[7] = includeHashForDuplicateFiles;
        $[8] = mediaClient;
        $[9] = occurrenceKey;
        $[10] = skipRemote;
        $[11] = t4;
        $[12] = t5;
    } else {
        t4 = $[11];
        t5 = $[12];
    }
    (0, $cozmU.useEffect)(t4, t5);
    const t6 = fileState ?? initialFileState;
    let t7;
    if ($[13] !== t6) {
        t7 = {
            fileState: t6
        };
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    return t7;
} : function useFileState(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles, initialFileState: initialFileState } = options;
    const mediaClient = (0, $lNvN4.useMediaClient)();
    const fileState = (0, $4fGOw.useMediaStore)((state)=>state.files[id]);
    // Capture initialFileState as a ref so it's a stable one-time SSR seed that
    // doesn't affect the useEffect dependency array. Including it directly would
    // cause repeated unsubscribe/resubscribe cycles whenever the caller passes a
    // new (unstabilized) object reference — each cycle fires getFileState before
    // the store is populated.
    const initialFileStateRef = (0, $cozmU.useRef)(initialFileState);
    (0, $cozmU.useEffect)(()=>{
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            initialFileState: initialFileStateRef.current,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState ?? initialFileState
    };
};
module.exports["useFileState"] = $387adc567339a7f4$export$90ff537b0999afb;

});

parcelRegister("9vt4W", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gOi68 = parcelRequire("gOi68");

var $4OSQA = parcelRequire("4OSQA");


var $4zScG = parcelRequire("4zScG");

var $h7nb4 = parcelRequire("h7nb4");

var $lNvN4 = parcelRequire("lNvN4");


var $9OT81 = parcelRequire("9OT81");


var $iDrrr = parcelRequire("iDrrr");


var $8BQV6 = parcelRequire("8BQV6");


var $joP8U = parcelRequire("joP8U");


var $j6hoF = parcelRequire("j6hoF");


var $61zD1 = parcelRequire("61zD1");

var $1FrxG = parcelRequire("1FrxG");

var $a0nKQ = parcelRequire("a0nKQ");


var $l32w2 = parcelRequire("l32w2");

var $a4SEC = parcelRequire("a4SEC");


var $gE3xj = parcelRequire("gE3xj");

// invisible gif for SSR preview to show the underlying spinner until the src is replaced by
// the actual image src in the inline script
const $88a5d6d53a08a849$var$DEFAULT_SSR_PREVIEW = {
    dataURI: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
    dimensions: {
        width: 100,
        height: 100
    },
    source: 'ssr-server'
};
const $88a5d6d53a08a849$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, useSrcSet: useSrcSet = false, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: // TODO: mediaBlobUrlAttrs can be missing several values contained in the file details. The preview hook is not updating the params in the preview after the file details are available.
allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source, initialFileState: initialFileState })=>{
    const mediaClient = (0, $lNvN4.useMediaClient)();
    const [status, setStatus] = (0, $cozmU.useState)('loading');
    const [error, setError] = (0, $cozmU.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $cozmU.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $cozmU.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $cozmU.useState)('not-resolved');
    const ssrReliabilityRef = (0, $cozmU.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const ufoContext = (0, $8BQV6.useInteractionContext)();
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (isLoading) return ufoContext?.hold('img-loading');
    }, [
        ufoContext,
        isLoading
    ]);
    const requestDimensions = (0, $cozmU.useMemo)(()=>dimensions ? (0, $gE3xj.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $gE3xj.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $a0nKQ.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $a4SEC.getSSRData)(identifier, resizeMode);
            if (ssrData?.error) ssrReliabilityRef.current = {
                ...ssrReliabilityRef.current,
                server: {
                    status: 'fail',
                    ...ssrData.error
                }
            };
            if (!ssrData?.dataURI) {
                // Only attempt SSR preview generation if:
                // 1. We're on the server (ssr='server'), OR
                // 2. We're on the client AND there is SSR data (meaning SSR actually happened)
                // If ssr='client' but there's no SSR data, it means this is a client-side navigation
                // where no SSR occurred, so we should skip SSR preview generation entirely.
                if (ssr === 'server' || ssrData) try {
                    // When the relay/SSR-seed path provided a pre-signed CDN URL,
                    // overlay its CDN-signing query params on the URL produced by
                    // getImageUrlSync. This makes the SSR-rendered HTML use the
                    // cdn-signed URL directly (no auth-token -> cdn-signed swap on
                    // hydration) and the 'ssr-data' rehydration path inherits it
                    // automatically via globalScope.
                    const seededCdnUrl = initialFileState && initialFileState.status !== 'error' ? initialFileState.previewCdnUrl : undefined;
                    const cdnSigningParams = seededCdnUrl && (0, $iDrrr.fg)('platform_media_ssr_data_seed') ? (0, $61zD1.extractCdnSigningParams)(seededCdnUrl) : undefined;
                    return (0, $61zD1.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs, cdnSigningParams);
                } catch (e) {
                    ssrReliabilityRef.current = {
                        ...ssrReliabilityRef.current,
                        [ssr]: {
                            status: 'fail',
                            ...(0, $joP8U.extractErrorInfo)(e, traceContext)
                        }
                    };
                }
            } else {
                const { dimensions: dimensions_0, dataURI: dataURI, srcSet: srcSet, loading: loading } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions_0,
                    source: 'ssr-data',
                    srcSet: srcSet,
                    lazy: loading === 'lazy'
                };
            }
        }
    };
    const [preview_0, setPreview] = (0, $cozmU.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $h7nb4.useFileState)(identifier.id, {
        initialFileState: initialFileState,
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $gOi68.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $cozmU.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (status !== 'error') {
            if (preview_0 || fileState?.status === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview_0 && fileState?.status === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $j6hoF.MediaFilePreviewError)('failed-processing'));
            } else if (!preview_0 && fileState?.status === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $j6hoF.MediaFilePreviewError)('metadata-fetch', (0, $4OSQA.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview_0,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // SSR Loading
    //----------------------------------------------------------------
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('media-perf-uplift-mutation-fix')) return;
        const loadPromise = (0, $a4SEC.getSSRData)(identifier, resizeMode)?.loadPromise;
        if (preview_0 && (0, $61zD1.isSSRDataPreview)(preview_0) && loadPromise) loadPromise.then(()=>{
            setStatus('complete');
        }).catch(()=>{
            setPreview(undefined);
        });
    }, [
        preview_0,
        identifier,
        resizeMode
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $gE3xj.useCurrentValueRef)(()=>{
        return (0, $61zD1.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $cozmU.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview_0) setUpfrontPreviewStatus('resolved');
        else if (!preview_0 && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            setIsLoading(true);
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $gE3xj.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setIsLoading(false);
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview_0,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $gE3xj.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $cozmU.useEffect)(()=>{
        const cachedPreview = (0, $a0nKQ.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview_0 && cachedPreview && !(0, $gE3xj.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview_0 && !isBannedLocalPreview && localBinary && (0, $1FrxG.isSupportedLocalPreview)(mediaType) && (0, $9OT81.isMimeTypeSupportedByBrowser)(mimeType || '')) {
            // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
            // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
            // Then, local Preview NOT available
            setIsLoading(true);
            (0, $61zD1.getAndCacheLocalPreview)(mediaClient, identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current, identifier.collectionName).then(setPreview).catch((e_0)=>{
                setIsBannedLocalPreview(true);
                // CXP-2723 TODO: We might have to wrap this error in MediaCardError
                setNonCriticalError(e_0);
            }).finally(()=>{
                setIsLoading(false);
            });
        } else if (!error && !nonCriticalError && (!preview_0 || (0, $gE3xj.isBigger)(preview_0.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $61zD1.isSSRPreview)(preview_0)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) {
            // If the preview is SSR, we can skip the refetch as it will be handled by the global scope promise
            // If the preview is not wider than the requested dimensions, we can skip the refetch
            if (preview_0 && (0, $61zD1.isSSRPreview)(preview_0) && !(0, $gE3xj.isWider)(preview_0.dimensions, dimensions) && (0, $iDrrr.fg)('media-perf-uplift-mutation-fix')) return;
            setIsLoading(true);
            getAndCacheRemotePreviewRef.current().then(setPreview).catch((e_1)=>{
                const wrappedError = (0, $j6hoF.ensureMediaFilePreviewError)('preview-fetch', e_1);
                if (!preview_0) {
                    setStatus('error');
                    setError(wrappedError);
                } else // If there is already a preview, we consider it a non-critical error
                setNonCriticalError(wrappedError);
            }).finally(()=>{
                setIsLoading(false);
            });
        }
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        identifier.collectionName,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        mediaClient,
        preview_0,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus,
        dimensions
    ]);
    //----------------------------------------------------------------
    // Cache ref tracking — prevent blob URL eviction while mounted
    //----------------------------------------------------------------
    (0, $cozmU.useEffect)(()=>{
        (0, $a0nKQ.mediaFilePreviewCache).acquire(identifier.id, resizeMode);
        return ()=>{
            (0, $a0nKQ.mediaFilePreviewCache).release(identifier.id, resizeMode);
        };
    }, [
        identifier.id,
        resizeMode
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $cozmU.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $61zD1.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current = {
            ...ssrReliabilityRef.current,
            client: (0, $joP8U.createFailedSSRObject)(failedPreview, traceContext)
        };
        const isSSR = (0, $61zD1.isSSRDataPreview)(failedPreview) || (0, $61zD1.isSSRClientPreview)(failedPreview);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if (isSSR) ssrReliabilityRef.current = {
            server: (0, $joP8U.createFailedSSRObject)(failedPreview, traceContext),
            client: (0, $joP8U.createFailedSSRObject)(failedPreview, traceContext)
        };
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview_0?.dataURI) return;
        const isLocal = (0, $61zD1.isLocalPreview)(failedPreview);
        const isRemote = (0, $61zD1.isRemotePreview)(failedPreview);
        if (isLocal || isRemote || isSSR) {
            const error_0 = new (0, $j6hoF.ImageLoadError)(failedPreview?.source);
            (0, $a0nKQ.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error_0);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview_0?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $cozmU.useCallback)((newPreview_0)=>{
        if (newPreview_0) {
            if ((0, $61zD1.isSSRClientPreview)(newPreview_0) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current = {
                ...ssrReliabilityRef.current,
                client: {
                    status: 'success'
                }
            };
            /*
          If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
        */ if ((0, $61zD1.isSSRDataPreview)(newPreview_0) && ssrReliabilityRef.current.server.status === 'unknown') ssrReliabilityRef.current = {
                server: {
                    status: 'success'
                },
                client: {
                    status: 'success'
                }
            };
            /*
      Handle 'ssr-server' source which is used when:
      1. ssr='server' is passed to getSSRPreview (server-side rendering)
      2. DEFAULT_SSR_PREVIEW is used (placeholder during SSR)
      This ensures ssrReliability is updated to 'success' when the server-rendered image loads.
      */ if (newPreview_0.source === 'ssr-server' && ssrReliabilityRef.current.server.status === 'unknown') ssrReliabilityRef.current = {
                server: {
                    status: 'success'
                },
                client: {
                    status: 'success'
                }
            };
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview_0?.dataURI !== preview_0?.dataURI) return;
    }, [
        preview_0?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $l32w2.generateScriptProps)(identifier, preview_0?.dataURI, resizeMode, preview_0?.srcSet, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined, {
            'media-perf-uplift-mutation-fix': (0, $iDrrr.fg)('media-perf-uplift-mutation-fix'),
            'media-perf-lazy-loading-optimisation': (0, $iDrrr.fg)('media-perf-lazy-loading-optimisation')
        }) : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $4zScG.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: ssr === 'server' && useSrcSet && (0, $iDrrr.fg)('media-perf-uplift-mutation-fix') ? $88a5d6d53a08a849$var$DEFAULT_SSR_PREVIEW : preview_0,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};
module.exports["useFilePreview"] = $88a5d6d53a08a849$export$4eaebdef02112fe4;

});

parcelRegister("4zScG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $iDrrr = parcelRequire("iDrrr");


var $lNvN4 = parcelRequire("lNvN4");


var $kbsbM = parcelRequire("kbsbM");


var $lCARa = parcelRequire("lCARa");


var $LCmg6 = parcelRequire("LCmg6");

function $53479886ecc2e2a4$var$useCurrentValueRef(value) {
    const ref = (0, $cozmU.useRef)(value);
    ref.current = value;
    return ref;
}
const $53479886ecc2e2a4$export$46fd859414de9d62 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (id, t0)=>{
    const $ = (0, $bDgLe.c)(20);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const options = t1;
    const mediaClient = (0, $lNvN4.useMediaClient)();
    const innerRef = (0, $cozmU.useRef)(null);
    const clientIdRef = (0, $cozmU.useRef)(undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t2;
    let t3;
    if ($[2] !== mediaClient || $[3] !== options.collectionName) {
        t2 = ()=>{
            if ((0, $iDrrr.fg)("platform_media_cross_client_copy_with_auth")) mediaClient.getClientId(options.collectionName).then((clientId)=>{
                clientIdRef.current = clientId;
            }).catch($53479886ecc2e2a4$var$_temp);
        };
        t3 = [
            mediaClient,
            options.collectionName
        ];
        $[2] = mediaClient;
        $[3] = options.collectionName;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[6] !== createAnalyticsEvent || $[7] !== id || $[8] !== mediaClient || $[9] !== options.collectionName) {
        t4 = async ()=>{
            try {
                await mediaClient.file.registerCopyIntent(id, options.collectionName);
                createAnalyticsEvent((0, $lCARa.getCopyIntentSuccessPayload)(id));
            } catch (t5) {
                const err = t5;
                createAnalyticsEvent((0, $kbsbM.getCopyIntentErrorPayload)(err, id));
            }
        };
        $[6] = createAnalyticsEvent;
        $[7] = id;
        $[8] = mediaClient;
        $[9] = options.collectionName;
        $[10] = t4;
    } else t4 = $[10];
    const registerCopyIntentRef = $53479886ecc2e2a4$var$useCurrentValueRef(t4);
    let t5;
    if ($[11] !== registerCopyIntentRef) {
        t5 = (elem)=>{
            innerRef.current = elem;
            if ((0, $iDrrr.fg)("platform_media_cross_client_copy")) elem?.addEventListener("contextmenu", ()=>{
                registerCopyIntentRef.current();
            });
        };
        $[11] = registerCopyIntentRef;
        $[12] = t5;
    } else t5 = $[12];
    const copyNodeRef = t5;
    let t6;
    if ($[13] !== registerCopyIntentRef) {
        t6 = (event)=>{
            const currentCopyTarget = innerRef.current;
            const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
            if (currentSelectionContainsNode) {
                registerCopyIntentRef.current();
                if ((0, $iDrrr.fg)("platform_media_cross_client_copy_with_auth")) {
                    const clientId_0 = clientIdRef.current;
                    const html = event.clipboardData?.getData("text/html");
                    if (html && html.includes("data-node-type=\"media") && clientId_0) {
                        const modifiedHtml = html.replace(/(<[^>]*data-node-type="media(?:Inline)?")([^>]*>)/g, `$1 data-client-id="${clientId_0}"$2`);
                        event.clipboardData?.setData("text/html", modifiedHtml);
                    }
                }
            }
        };
        $[13] = registerCopyIntentRef;
        $[14] = t6;
    } else t6 = $[14];
    const onGlobalCopy = t6;
    let t7;
    let t8;
    if ($[15] !== onGlobalCopy) {
        t7 = ()=>{
            if ((0, $iDrrr.fg)("platform_media_cross_client_copy")) (0, $LCmg6.getDocument)()?.addEventListener("copy", onGlobalCopy);
            return ()=>(0, $LCmg6.getDocument)()?.removeEventListener("copy", onGlobalCopy);
        };
        t8 = [
            onGlobalCopy
        ];
        $[15] = onGlobalCopy;
        $[16] = t7;
        $[17] = t8;
    } else {
        t7 = $[16];
        t8 = $[17];
    }
    (0, $cozmU.useEffect)(t7, t8);
    let t9;
    if ($[18] !== copyNodeRef) {
        t9 = {
            copyNodeRef: copyNodeRef
        };
        $[18] = copyNodeRef;
        $[19] = t9;
    } else t9 = $[19];
    return t9;
} : (id, options = {})=>{
    const mediaClient = (0, $lNvN4.useMediaClient)();
    const innerRef = (0, $cozmU.useRef)(null);
    const clientIdRef = (0, $cozmU.useRef)(undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    // Pre-fetch clientId so it's available synchronously during copy event
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('platform_media_cross_client_copy_with_auth')) mediaClient.getClientId(options.collectionName).then((clientId)=>{
            clientIdRef.current = clientId;
        }).catch(()=>{
        // Silently handle - product might not have authProvider configured
        });
    }, [
        mediaClient,
        options.collectionName
    ]);
    const registerCopyIntentRef = $53479886ecc2e2a4$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $lCARa.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $kbsbM.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $cozmU.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $iDrrr.fg)('platform_media_cross_client_copy')) elem?.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $cozmU.useCallback)((event)=>{
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
        if (currentSelectionContainsNode) {
            registerCopyIntentRef.current();
            // Add clientId to the copied HTML (must be synchronous)
            if ((0, $iDrrr.fg)('platform_media_cross_client_copy_with_auth')) {
                const clientId_0 = clientIdRef.current;
                const html = event.clipboardData?.getData('text/html');
                // Look for media nodes by data-node-type which is always present
                if (html && html.includes('data-node-type="media') && clientId_0) {
                    // Insert data-client-id after data-node-type="media" or data-node-type="mediaInline"
                    const modifiedHtml = html.replace(/(<[^>]*data-node-type="media(?:Inline)?")([^>]*>)/g, `$1 data-client-id="${clientId_0}"$2`);
                    event.clipboardData?.setData('text/html', modifiedHtml);
                }
            }
        }
    }, [
        registerCopyIntentRef
    ]);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('platform_media_cross_client_copy')) (0, $LCmg6.getDocument)()?.addEventListener('copy', onGlobalCopy);
        return ()=>(0, $LCmg6.getDocument)()?.removeEventListener('copy', onGlobalCopy);
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};
function $53479886ecc2e2a4$var$_temp() {}
module.exports["useCopyIntent"] = $53479886ecc2e2a4$export$46fd859414de9d62;

});

parcelRegister("kbsbM", function(module, exports) {

var $kQ37v = parcelRequire("kQ37v");

const $e7672981c7c11579$var$getRequestErrorDetails = (err)=>{
    if ((0, $kQ37v.isRequestError)(err)) return {
        request: {
            statusCode: err.metadata?.statusCode,
            traceContext: err.metadata?.traceContext,
            mediaEnv: err.metadata?.mediaEnv,
            mediaRegion: err.metadata?.mediaRegion
        }
    };
    return undefined;
};
const $e7672981c7c11579$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $kQ37v.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$e7672981c7c11579$var$getRequestErrorDetails(error)
        }
    };
};
module.exports["getCopyIntentErrorPayload"] = $e7672981c7c11579$export$3ab52330b662b987;

});

parcelRegister("lCARa", function(module, exports) {
const $6286d594fdfca498$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};
module.exports["getCopyIntentSuccessPayload"] = $6286d594fdfca498$export$aacb463551da2e8f;

});

parcelRegister("LCmg6", function(module, exports) {
const $92acd99a6d98db3f$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};
module.exports["getDocument"] = $92acd99a6d98db3f$export$f65ca476c09acec0;

});

parcelRegister("joP8U", function(module, exports) {

var $4OSQA = parcelRequire("4OSQA");


var $j6hoF = parcelRequire("j6hoF");

const $f6a8566e9c76eb8c$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4OSQA.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $f6a8566e9c76eb8c$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $f6a8566e9c76eb8c$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4OSQA.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $f6a8566e9c76eb8c$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4OSQA.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};
const $f6a8566e9c76eb8c$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $f6a8566e9c76eb8c$export$4af9d71992e89714(error),
        error: $f6a8566e9c76eb8c$export$88c61dcad53762da(error),
        errorDetail: $f6a8566e9c76eb8c$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $f6a8566e9c76eb8c$export$29aa614726672b2e(error)
    };
};
const $f6a8566e9c76eb8c$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$f6a8566e9c76eb8c$export$74aaf4784c2edb2c(new (0, $j6hoF.ImageLoadError)(preview.source), metadataTraceContext)
    });
module.exports["extractErrorInfo"] = $f6a8566e9c76eb8c$export$74aaf4784c2edb2c;
module.exports["createFailedSSRObject"] = $f6a8566e9c76eb8c$export$768c370ed0dbaeb3;

});

parcelRegister("j6hoF", function(module, exports) {
class $71061d29c37eeba3$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $71061d29c37eeba3$export$2c035820a31723e extends $71061d29c37eeba3$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $71061d29c37eeba3$export$10ab445310d30114 extends $71061d29c37eeba3$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $71061d29c37eeba3$export$18e89b7e50818288 extends $71061d29c37eeba3$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $71061d29c37eeba3$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $71061d29c37eeba3$export$d0a45ab59b4606b extends $71061d29c37eeba3$export$96e559194c287cf4 {
    constructor(source){
        super($71061d29c37eeba3$var$getImageLoadPrimaryReason(source));
    }
}
function $71061d29c37eeba3$export$553696a6e769784c(err) {
    return err instanceof $71061d29c37eeba3$export$96e559194c287cf4;
}
const $71061d29c37eeba3$export$b380593ba3516c6f = (err)=>err instanceof $71061d29c37eeba3$export$2c035820a31723e;
const $71061d29c37eeba3$export$e1d87830b3784f94 = (err)=>err instanceof $71061d29c37eeba3$export$10ab445310d30114;
const $71061d29c37eeba3$export$443aeb298d35d79d = (err)=>$71061d29c37eeba3$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $71061d29c37eeba3$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($71061d29c37eeba3$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $71061d29c37eeba3$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $71061d29c37eeba3$export$96e559194c287cf4(primaryReason, error);
};
module.exports["MediaFilePreviewError"] = $71061d29c37eeba3$export$96e559194c287cf4;
module.exports["LocalPreviewError"] = $71061d29c37eeba3$export$2c035820a31723e;
module.exports["RemotePreviewError"] = $71061d29c37eeba3$export$10ab445310d30114;
module.exports["SsrPreviewError"] = $71061d29c37eeba3$export$18e89b7e50818288;
module.exports["ImageLoadError"] = $71061d29c37eeba3$export$d0a45ab59b4606b;
module.exports["ensureMediaFilePreviewError"] = $71061d29c37eeba3$export$7156ce7b78b49bd7;

});

parcelRegister("61zD1", function(module, exports) {

var $6wYuL = parcelRequire("6wYuL");


var $iDrrr = parcelRequire("iDrrr");


var $j6hoF = parcelRequire("j6hoF");


var $a0nKQ = parcelRequire("a0nKQ");


var $1FrxG = parcelRequire("1FrxG");

const $d8a1d04f617229a6$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $6wYuL.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $a0nKQ.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
/**
 * Allowlist of CDN signing query-param names that we propagate from a
 * pre-signed `previewCdnUrl` onto the URL produced by `getImageUrlSync`.
 * These are the standard CloudFront signed-URL params; if the upstream
 * adds a new one, this list needs updating.
 */ const $d8a1d04f617229a6$var$SIGNING_PARAM_NAMES = [
    'token',
    'Policy',
    'Key-Pair-Id',
    'Signature',
    'Expires'
];
const $d8a1d04f617229a6$export$8b90d6fc9c946379 = (cdnUrl)=>{
    try {
        const url = new URL(cdnUrl);
        const out = {};
        for (const name of $d8a1d04f617229a6$var$SIGNING_PARAM_NAMES){
            const value = url.searchParams.get(name);
            if (value !== null) out[name] = value;
        }
        return out;
    } catch  {
        return {};
    }
};
const $d8a1d04f617229a6$var$applyCdnSigningParams = (url, cdnSigningParams)=>{
    if (!cdnSigningParams || Object.keys(cdnSigningParams).length === 0) return url;
    try {
        const parsed = new URL(url);
        Object.entries(cdnSigningParams).forEach(([key, value])=>{
            parsed.searchParams.set(key, value);
        });
        return parsed.toString();
    } catch  {
        return url;
    }
};
const $d8a1d04f617229a6$var$getDataUri = (mediaClient, id, params, mediaBlobUrlAttrs, cdnSigningParams)=>{
    const rawDataURI = mediaClient.getImageUrlSync(id, params);
    const signedDataURI = $d8a1d04f617229a6$var$applyCdnSigningParams(rawDataURI, cdnSigningParams);
    return mediaBlobUrlAttrs ? (0, $6wYuL.addFileAttrsToUrl)(signedDataURI, mediaBlobUrlAttrs) : signedDataURI;
};
/**
 * Merges a clientId into mediaBlobUrlAttrs for cross-client copy support.
 * Returns the original attrs unchanged if clientId is not available or the feature flag is off.
 */ const $d8a1d04f617229a6$var$mergeClientIdIntoAttrs = (clientId, id, mediaBlobUrlAttrs, collectionName)=>{
    if (!clientId) return mediaBlobUrlAttrs;
    if (mediaBlobUrlAttrs) return {
        ...mediaBlobUrlAttrs,
        clientId: clientId
    };
    // Construct minimal attrs when none provided
    return {
        id: id,
        clientId: clientId,
        contextId: collectionName || '',
        collection: collectionName
    };
};
const $d8a1d04f617229a6$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs, cdnSigningParams)=>{
    try {
        // Synchronously extract clientId from initialAuth and merge into blob URL attrs
        const clientId = (0, $iDrrr.fg)('platform_media_cross_client_copy_with_auth') ? mediaClient.getClientIdSync() : undefined;
        const attrsWithClientId = $d8a1d04f617229a6$var$mergeClientIdIntoAttrs(clientId, id, mediaBlobUrlAttrs, params.collection);
        const dataURI = $d8a1d04f617229a6$var$getDataUri(mediaClient, id, params, attrsWithClientId, cdnSigningParams);
        let srcSet = `${dataURI} 1x`;
        if (params.width) {
            const doubleDataURI = $d8a1d04f617229a6$var$getDataUri(mediaClient, id, {
                ...params,
                width: params.width * 2,
                height: params.height && params.height * 2
            }, attrsWithClientId, cdnSigningParams);
            // We want to embed some meta context into dataURI for Copy/Paste to work.
            srcSet += `, ${doubleDataURI} 2x`;
        }
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1,
            srcSet: srcSet
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $j6hoF.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $d8a1d04f617229a6$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $d8a1d04f617229a6$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $d8a1d04f617229a6$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $d8a1d04f617229a6$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $d8a1d04f617229a6$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
/**
 * Resolves clientId (sync first, async fallback) and enriches mediaBlobUrlAttrs
 * with it for cross-client copy support.
 */ const $d8a1d04f617229a6$var$enrichAttrsWithClientId = async (mediaClient, id, mediaBlobUrlAttrs, collectionName)=>{
    if (!(0, $iDrrr.fg)('platform_media_cross_client_copy_with_auth')) return mediaBlobUrlAttrs;
    // Try sync first, then async fallback
    let clientId = mediaClient.getClientIdSync();
    if (!clientId) try {
        clientId = await mediaClient.getClientId(collectionName);
    } catch  {
    // clientId is optional, silently fail
    }
    return $d8a1d04f617229a6$var$mergeClientIdIntoAttrs(clientId, id, mediaBlobUrlAttrs, collectionName);
};
const $d8a1d04f617229a6$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const [remotePreview, enrichedAttrs] = await Promise.all([
        (0, $1FrxG.getRemotePreview)(mediaClient, id, params, traceContext),
        $d8a1d04f617229a6$var$enrichAttrsWithClientId(mediaClient, id, mediaBlobUrlAttrs, params.collection)
    ]);
    return $d8a1d04f617229a6$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, enrichedAttrs);
};
const $d8a1d04f617229a6$export$98e935d981c884d = async (mediaClient, id, filePreview, dimensions, mode, mediaBlobUrlAttrs, collectionName)=>{
    const [localPreview, enrichedAttrs] = await Promise.all([
        (0, $1FrxG.getLocalPreview)(filePreview),
        $d8a1d04f617229a6$var$enrichAttrsWithClientId(mediaClient, id, mediaBlobUrlAttrs, collectionName)
    ]);
    return $d8a1d04f617229a6$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, enrichedAttrs);
};
module.exports["extractCdnSigningParams"] = $d8a1d04f617229a6$export$8b90d6fc9c946379;
module.exports["getSSRPreview"] = $d8a1d04f617229a6$export$faf1c301c59a1bdc;
module.exports["isLocalPreview"] = $d8a1d04f617229a6$export$78ad02c5efc361c9;
module.exports["isRemotePreview"] = $d8a1d04f617229a6$export$87442a14a8a19e0;
module.exports["isSSRClientPreview"] = $d8a1d04f617229a6$export$36aae1afbc0a9661;
module.exports["isSSRDataPreview"] = $d8a1d04f617229a6$export$f366c2c8a792cce6;
module.exports["isSSRPreview"] = $d8a1d04f617229a6$export$dea79d05143ccf4;
module.exports["getAndCacheRemotePreview"] = $d8a1d04f617229a6$export$49721bcc26fb9388;
module.exports["getAndCacheLocalPreview"] = $d8a1d04f617229a6$export$98e935d981c884d;

});

parcelRegister("a0nKQ", function(module, exports) {

var $jx0Wk = parcelRequire("jx0Wk");

const $017d76cb8cfc0c2c$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $017d76cb8cfc0c2c$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $017d76cb8cfc0c2c$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $017d76cb8cfc0c2c$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $017d76cb8cfc0c2c$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
        this.acquire = (id, mode)=>{
            const cacheKey = $017d76cb8cfc0c2c$export$611736262b635f8d(id, mode);
            this.previewCache.acquire(cacheKey);
        };
        this.release = (id, mode)=>{
            const cacheKey = $017d76cb8cfc0c2c$export$611736262b635f8d(id, mode);
            this.previewCache.release(cacheKey);
        };
    }
}
const $017d76cb8cfc0c2c$export$b7e8ee3f7a41459 = new $017d76cb8cfc0c2c$export$7b50526c091bb915((0, $jx0Wk.createObjectURLCache)());
module.exports["mediaFilePreviewCache"] = $017d76cb8cfc0c2c$export$b7e8ee3f7a41459;

});

parcelRegister("jx0Wk", function(module, exports) {

var $lPEt0 = parcelRequire("lPEt0");

const $ff738ace400485a0$export$36d0f9859761643d = 50;
/**
 * LRU cache that checks whether the oldest entry should be evicted
 * this means that the cache can grow past the softLimit if `shouldEvict` returns false.
 *
 * The oldest entry is kept if `shouldEvict` returns false.
 */ class $ff738ace400485a0$var$EvictionLRUCache extends (0, $lPEt0.LRUMap) {
    shift() {
        const oldest = this.oldest;
        if (oldest && this.shouldEvict && !this.shouldEvict([
            oldest.key,
            oldest.value
        ])) return undefined;
        const entry = super.shift();
        if (entry && this.onEvict) this.onEvict(entry);
        return entry;
    }
    constructor(softLimit, options){
        super(softLimit);
        this.shouldEvict = void 0;
        this.onEvict = void 0;
        this.shouldEvict = options?.shouldEvict;
        this.onEvict = options?.onEvict;
    }
}
class $ff738ace400485a0$export$75d1c8c9ba1d0773 {
    /**
   * Marks a cache key as actively in use by a consumer.
   * Multiple consumers can acquire the same key; eviction is
   * blocked until all consumers have released it.
   */ acquire(key) {
        this.activeRefs.set(key, (this.activeRefs.get(key) ?? 0) + 1);
    }
    release(key) {
        const count = this.activeRefs.get(key) ?? 0;
        if (count <= 1) this.activeRefs.delete(key);
        else this.activeRefs.set(key, count - 1);
    }
    isInUse(key) {
        return (this.activeRefs.get(key) ?? 0) > 0;
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        this.activeRefs.delete(key);
        const dataURI = removed?.dataURI.split('#')[0];
        dataURI && URL.revokeObjectURL(dataURI);
    }
    clear() {
        this.cache.clear();
    }
    constructor(size){
        this.cache = void 0;
        this.activeRefs = new Map();
        this.cache = new $ff738ace400485a0$var$EvictionLRUCache(size, {
            shouldEvict: (entry)=>!this.isInUse(entry[0]),
            onEvict: (entry)=>{
                if (entry[1].dataURI) {
                    const dataURI = entry[1].dataURI.split('#')[0];
                    if (dataURI) URL.revokeObjectURL(dataURI);
                }
            }
        });
    }
}
const $ff738ace400485a0$export$ba71be67d5c32535 = ()=>new $ff738ace400485a0$export$75d1c8c9ba1d0773($ff738ace400485a0$export$36d0f9859761643d);
module.exports["createObjectURLCache"] = $ff738ace400485a0$export$ba71be67d5c32535;

});

parcelRegister("1FrxG", function(module, exports) {

var $nfEzS = parcelRequire("nfEzS");


var $edV3B = parcelRequire("edV3B");


var $j6hoF = parcelRequire("j6hoF");


var $599Ht = parcelRequire("599Ht");

const $326902bd67ba4ecb$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $326902bd67ba4ecb$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $edV3B.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $j6hoF.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $326902bd67ba4ecb$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $599Ht.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $j6hoF.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $326902bd67ba4ecb$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $j6hoF.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $nfEzS.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $326902bd67ba4ecb$var$getImageLocalPreview(value);
            case 'video':
                return $326902bd67ba4ecb$var$getVideoLocalPreview(value);
            default:
                throw new (0, $j6hoF.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $j6hoF.LocalPreviewError)('local-preview-unsupported');
};
const $326902bd67ba4ecb$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $j6hoF.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};
module.exports["isSupportedLocalPreview"] = $326902bd67ba4ecb$export$1fa85b75e8662d54;
module.exports["getLocalPreview"] = $326902bd67ba4ecb$export$3d6ed68e437b8c99;
module.exports["getRemotePreview"] = $326902bd67ba4ecb$export$bfe20bd01db02b3;

});

parcelRegister("599Ht", function(module, exports) {
const $e9eb3851d008a755$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};
module.exports["takeSnapshot"] = $e9eb3851d008a755$export$4269d30173168e5c;

});

parcelRegister("l32w2", function(module, exports) {
const $df091675c0f8d5b7$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $df091675c0f8d5b7$export$d26005e8749921c9 = 'mediaCountSsr';
const $df091675c0f8d5b7$export$7aeb4eab53a57df7 = 'performanceEntries';
const $df091675c0f8d5b7$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
const $df091675c0f8d5b7$var$MAX_EAGER_LOAD_COUNT = 6;
function $df091675c0f8d5b7$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $df091675c0f8d5b7$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $df091675c0f8d5b7$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $df091675c0f8d5b7$var$dashed = (param)=>param ? `-${param}` : '';
const $df091675c0f8d5b7$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey }, resizeMode)=>`${id}${$df091675c0f8d5b7$var$dashed(collectionName)}${$df091675c0f8d5b7$var$dashed(occurrenceKey)}${$df091675c0f8d5b7$var$dashed(resizeMode)}`;
const $df091675c0f8d5b7$var$generateScript = (identifier, dataURI, mode, srcSet, dimensions, error, featureFlags = {})=>{
    const key = $df091675c0f8d5b7$export$a47fb462a08de82f(identifier, mode);
    // Serialize the parameters for injection into the script
    const params = {
        key: key,
        dataURI: dataURI,
        mode: mode,
        srcSet: srcSet,
        dimensions: dimensions,
        error: error,
        featureFlags: featureFlags,
        maxEagerLoadCount: $df091675c0f8d5b7$var$MAX_EAGER_LOAD_COUNT
    };
    // Read originalScriptCode.ts before making changes
    return `!function(e){var r=document.currentScript,i=window.__MEDIA_INTERNAL=window.__MEDIA_INTERNAL||{},n=i.mediaCardSsr=i.mediaCardSsr||{},o=e.key,t=e.dataURI,d=e.mode,a=e.srcSet,s=e.dimensions,m=e.error,l=e.featureFlags;if(l["media-perf-uplift-mutation-fix"]){var u,c,f=n[o],v=f&&f.mode===d&&(null===(u=f.dimensions)||void 0===u?void 0:u.width)&&(null==s?void 0:s.width)&&f.dimensions.width>s.width,E=v?f.srcSet:a,p=v?f.dataURI:t,w={dataURI:p,dimensions:s,error:m,srcSet:E,loading:"lazy",loadPromise:void 0,mode:d},S=null==r||null===(c=r.parentElement)||void 0===c?void 0:c.querySelector("img");if(i.mediaCountSsr=i.mediaCountSsr||0,S){if(l["media-perf-lazy-loading-optimisation"]&&i.mediaCountSsr<e.maxEagerLoadCount){i.mediaCountSsr++,S.removeAttribute("loading"),w.loading="";var g=new PerformanceObserver((function(e){e.getEntries().forEach((function(e){E.includes(e.name)&&(i.performanceEntries=i.performanceEntries||[],i.performanceEntries.push(e),g.disconnect())}))}));g.observe({type:"resource"})}p&&(S.src=p),E&&(S.srcset=E),w.loadPromise=new Promise((function(e,r){S.addEventListener("load",(function(){return e()})),S.addEventListener("error",(function(){return r(new Error("Failed to load image"))}))}))}n[o]=v?f:w}else n[o]={dataURI:t,dimensions:s,error:m};null==r||r.remove()}({replace:""});`.replace('{replace:""}', JSON.stringify(params));
};
const $df091675c0f8d5b7$export$de7c49925e44d75d = (identifier, dataURI, mode, srcSet, dimensions, error, featureFlags = {})=>({
        dangerouslySetInnerHTML: {
            __html: $df091675c0f8d5b7$var$generateScript(identifier, dataURI, mode, srcSet, dimensions, error, featureFlags)
        }
    });
module.exports["getMediaCardSSR"] = $df091675c0f8d5b7$export$ede93d4564eaa8da;
module.exports["getKey"] = $df091675c0f8d5b7$export$a47fb462a08de82f;
module.exports["generateScriptProps"] = $df091675c0f8d5b7$export$de7c49925e44d75d;

});

parcelRegister("a4SEC", function(module, exports) {

var $l32w2 = parcelRequire("l32w2");

const $b4afaddd3336dcb8$export$d3a890b0f7844b6f = (identifier, resizeMode)=>{
    const mediaCardSsr = (0, $l32w2.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $l32w2.getKey)(identifier, resizeMode)];
};
module.exports["getSSRData"] = $b4afaddd3336dcb8$export$d3a890b0f7844b6f;

});

parcelRegister("gE3xj", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $c46a7830eda9de64$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
const $c46a7830eda9de64$export$ae6224430098bc5f = (current, next)=>{
    if (current === undefined && next !== undefined) return true;
    const currentWidth = current?.width || 0;
    const nextWidth = next?.width || 0;
    return currentWidth < nextWidth;
};
/** Verifies if the current screen is retina display */ function $c46a7830eda9de64$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $c46a7830eda9de64$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $c46a7830eda9de64$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $c46a7830eda9de64$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $cozmU.useRef)(value);
    ref.current = value;
    return ref;
}
module.exports["isBigger"] = $c46a7830eda9de64$export$912a00e9a5470d9a;
module.exports["isWider"] = $c46a7830eda9de64$export$ae6224430098bc5f;
module.exports["createRequestDimensions"] = $c46a7830eda9de64$export$3063221e86a58f9;
module.exports["useCurrentValueRef"] = $c46a7830eda9de64$export$b3e10e1f0fbb71db;

});


//# sourceMappingURL=media-viewer-error-boundary.24fd24ce.js.map
